import { loadFilterReducer } from '../../filter/reducers/FilterReducer';
import filterSaga from '../../filter/sagas/FilterSagas';
const loadFilterModule = (initialData) => ({
    id: 'Filter',
    reducerMap: {
        filters: loadFilterReducer(initialData ? initialData.filters : null),
    },
    sagas: [filterSaga],
});
export default loadFilterModule;
